class ConverterHelper {
    public static hexToRgb(hex: string) {
        let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        } : null;
    }

    public static getPercentage = (current: number, goal: number, maxPercentage = 100) => {
        const percentage = goal ? ((current / goal) * 100) : 100;
        return percentage > maxPercentage ? maxPercentage : percentage;
    }

    public static bytesToSize = (bytes: number) => {
        var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
        if (bytes === 0) return '0 Byte';
        var i = parseInt((Math.floor(Math.log(bytes) / Math.log(1024))).toString());
        return Math.round(bytes / Math.pow(1024, i)) + ' ' + sizes[i];
    }
}

export default ConverterHelper;